import React from 'react';

const Navigation  = ({isVisible, navigateToCountry}) => (<nav className={isVisible ? '' : 'hidden'}>
		<div className="nav-item"><div onClick={() => navigateToCountry('ukraine')}>UKRAINE</div></div>
		<div className="nav-item"><div onClick={() => navigateToCountry('poland')}>POLAND</div></div>
		<div className="nav-item"><div onClick={() => navigateToCountry('germany')}>GERMANY</div></div>
	</nav>)

export default Navigation;